import __base_store from '@/store/__base_store'

/**
 * Store de cheques (modelo `cheque`) construido desde el factory común.
 */
export default __base_store({
	state: {
		model_name: 'cheque',
	},
})

